// src/components/Footer.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import Styles from '../pages/styles.module.css';

function Footer() {
  const { t } = useTranslation();
  return (
    <div className={Styles.footer}>
      <p className={Styles.footerText}>{t('© 2024 Your Company. All Rights Reserved.')}</p>
    </div>
  );
}

export default Footer;
